<ng-container *ngIf="cell.imgSrc; else listRowTitle">
    <sh-media-block
        [imgSrc]="cell.imgSrc"
        [imgAlt]="cell.imgAlt"
        (click)="onMediaClick($event)"
        (keydown.enter)="onMediaClick($event)"
        [dragString]="dragData$ | async"
        [processing]="isProcessing"
        [previewError]="hasPreviewError"
        [previewMessage]="placeholderMessage"
    >
        <ng-container *ngTemplateOutlet="listRowTitle"></ng-container>
    </sh-media-block>
</ng-container>

<ng-template #listRowTitle>
    <sh-list-row-title [title]="cell.title" [info]="cell.info" [navigationLink]="cell.navigationLink" [dragString]="dragData$ | async"></sh-list-row-title>
</ng-template>
